import { ssrApi } from 'api/ssr';
import { AllCollectionsPage, Props } from 'components/template/collections-all';

export default function CollectionCasino({ collections }: Props) {
  return <AllCollectionsPage collections={collections} />;
}

export async function getServerSideProps() {
  const results = (await ssrApi.slotCollections.list())?.map((item) => ({
    ...item,
    type: 'slot',
  }));

  return {
    props: { collections: results },
  };
}
